import { FormattedMessage } from 'react-intl'
import { Box } from '@material-ui/core'
import React from 'react'
import { useCheckMMUserCountry } from '@src/utils/useCheckUserCountry'
import countriesMap from '@localization/countries.json'

interface LeadTimeProps {
  leadTime?: number | null
}

const LeadTime: React.FC<LeadTimeProps> = ({ leadTime }) => {
  const isKoreaMMUser = useCheckMMUserCountry(countriesMap.KR.countryCode)

  if (!isKoreaMMUser || !leadTime) return null

  return (
    <span>
      {', '}
      <FormattedMessage
        id="ESTIMATED_LEAD_TIME"
        defaultMessage="Estimated Lead Time"
      />
      <Box ml={1} mr={1} component="span">
        {leadTime}
      </Box>
      <FormattedMessage id="DAYS" defaultMessage="Days" />
    </span>
  )
}

export default LeadTime
